import { useEffect, useState } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import { useSite } from '../context/SiteContext';
import './Navbar.css';

const logoSrc = `${process.env.PUBLIC_URL ?? ''}/logo.png`;

const staticNavItems = [
  { to: '/', label: 'Anasayfa', end: true },
  { to: '/davetiyeler', label: 'Davetiyeler' },
  { to: '/sekerlik', label: 'Şekerlik' },
  { to: '/hakkimizda', label: 'Hakkımızda' },
];

export default function Navbar() {
  const { siteName, featuredDigitalSlug } = useSite();
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    ...staticNavItems.slice(0, 3),
    { to: `/${featuredDigitalSlug}`, label: 'Dijital Davetiye' },
    staticNavItems[3],
  ];

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  return (
    <header className="site-header">
      <div className="site-header__logo-band">
        <div className="container site-header__logo-inner">
          <Link to="/" className="site-logo">
            <img
              src={logoSrc}
              alt={siteName}
              className="site-logo__img"
              width={200}
              height={76}
              decoding="async"
            />
          </Link>
        </div>
      </div>

      <div className="site-header__nav-band">
        <div className="container site-header__nav-inner">
          <button
            type="button"
            className="nav-toggle"
            aria-expanded={menuOpen}
            aria-controls="primary-nav"
            aria-label={menuOpen ? 'Menüyü kapat' : 'Menüyü aç'}
            onClick={() => setMenuOpen((open) => !open)}
          >
            <span className={`nav-toggle__box${menuOpen ? ' is-open' : ''}`}>
              <span className="nav-toggle__line" />
              <span className="nav-toggle__line" />
              <span className="nav-toggle__line" />
            </span>
            <span className="nav-toggle__text">Menü</span>
          </button>

          <nav
            id="primary-nav"
            className={`primary-nav${menuOpen ? ' is-open' : ''}`}
            aria-label="Ana menü"
          >
            {navItems.map(({ to, label, end }) => (
              <NavLink
                key={to}
                to={to}
                end={end}
                className="primary-nav__link"
                onClick={() => setMenuOpen(false)}
              >
                {label}
              </NavLink>
            ))}
          </nav>
        </div>
      </div>
    </header>
  );
}
